import { render, staticRenderFns } from "./PanelNavigation.vue?vue&type=template&id=098fbcdc&scoped=true"
import script from "./PanelNavigation.vue?vue&type=script&lang=js"
export * from "./PanelNavigation.vue?vue&type=script&lang=js"
import style0 from "./PanelNavigation.vue?vue&type=style&index=0&id=098fbcdc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098fbcdc",
  null
  
)

export default component.exports